import { supabaseManager } from '@/services/supabaseManager';
import { OrganizationService } from '@/services/organizations/organizationService';
import type { AuthStoreGet, AuthStoreSet, SignUpWithOrganizationData } from './auth.types';

export const createSignupActions = (set: AuthStoreSet, get: AuthStoreGet) => ({
  signUp: async (email: string, password: string, fullName: string): Promise<{ error: Error | null }> => {
    try {
      set({ loading: true });
      const { error } = await supabaseManager.getMainClient().auth.signUp({
        email,
        password,
        options: { data: { full_name: fullName } },
      });
      return { error: error || null };
    } catch (error) {
      return { error };
    } finally {
      set({ loading: false });
    }
  },

  signUpWithOrganization: async (data: SignUpWithOrganizationData): Promise<{ error: Error | null }> => {
    try {
      set({ loading: true });

      const result = await supabaseManager.createUserAndOrganization(data);
      if (result.error) return { error: result.error };

      if (import.meta.env.DEV) {
        await supabaseManager.connectToOrganizationBySlug(data.organizationSlug);
        const client = supabaseManager.getCurrentClient();
        const { data: authData, error: authError } = await client.auth.signInWithPassword({
          email: data.email,
          password: data.password,
        });

        if (authError?.message?.includes('Email not confirmed')) return { error: null };
        if (authError) return { error: authError };

        if (authData.user && authData.session) {
          set({
            user: authData.user,
            session: authData.session,
            isAuthenticated: true,
          });
          get().applyMemberOperator();
          localStorage.setItem('currentOrganizationSlug', data.organizationSlug);

          const { notifyOrganizationChange } = await import('../authStore');
          notifyOrganizationChange();

          await get().fetchUserProfile(authData.user.id);
        }
      }

      return { error: null };
    } catch (error) {
      return { error };
    } finally {
      set({ loading: false });
    }
  },
});
